import { render, staticRenderFns } from "./declareSearch.vue?vue&type=template&id=047c3141&scoped=true"
import script from "./declareSearch.vue?vue&type=script&lang=js"
export * from "./declareSearch.vue?vue&type=script&lang=js"
import style0 from "./declareSearch.vue?vue&type=style&index=0&id=047c3141&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047c3141",
  null
  
)

export default component.exports